import { Component, ErrorInfo, ReactNode } from "react";
import * as Sentry from "@sentry/browser";
import Primary from "./layouts/Primary";
import {t} from "../i18n";

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error
}

export default class DisplayErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    Sentry.captureException(error)
  }

  resetError() {
    this.setState({ hasError: false })
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <Primary>
        <h2>{t`Something went wrong.  Please contact FIRST event support.`}</h2>
        <details style={{ whiteSpace: 'pre-wrap', fontSize: '20px', fontWeight: 'normal', textAlign: 'left', margin: '10px' }}>
          {this.state.error && this.state.error.toString()}
        </details>
      </Primary>
    }

    return this.props.children;
  }
}